import { Component, ReactNode } from 'react';
import { ErrorService } from '../../services/errorService';
import { ErrorMessage } from '../../components/error/ErrorMessage';

interface Props {
  children: ReactNode;
  fallback?: ({ error }: { error: Error }) => ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class AuthErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    ErrorService.handle(error, {
      severity: 'high',
      userMessage: 'Authentication error occurred',
      context: { errorInfo }
    });
  }

  render() {
    if (this.state.hasError && this.state.error) {
      return this.props.fallback ? 
        this.props.fallback({ error: this.state.error }) : 
        <ErrorMessage
          message="Authentication error occurred"
          action={() => window.location.reload()}
          actionLabel="Try Again"
          variant="card"
        />;
    }
    return this.props.children;
  }
} 